export default function WorldIcon({ width = 24, height = 24, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      {...props}
    >
      <g clipPath="url(#a)">
        <path
          fill="#FEFEFE"
          d="M12.246 2.589a9.75 9.75 0 1 0 9.75 9.75 9.76 9.76 0 0 0-9.75-9.75Zm7.347 6h-3.321a13.347 13.347 0 0 0-1.9-4.219 8.284 8.284 0 0 1 5.221 4.219Zm-7.347-4.49c1.125 1.219 1.969 2.77 2.472 4.49H9.774c.503-1.72 1.347-3.27 2.472-4.49Zm-3 8.24c0-.754.063-1.507.188-2.25h5.625c.248 1.49.248 3.01 0 4.5H9.434a13.621 13.621 0 0 1-.188-2.25Zm.528 3.75h4.944c-.503 1.72-1.347 3.269-2.472 4.49-1.125-1.221-1.969-2.77-2.472-4.49Zm4.598 4.219a13.347 13.347 0 0 0 1.9-4.22h3.321a8.286 8.286 0 0 1-5.22 4.22Zm2.206-5.72a15.171 15.171 0 0 0 0-4.5h3.606a8.263 8.263 0 0 1 0 4.5h-3.606Z"
        />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M.246.339h24v24h-24z" />
        </clipPath>
      </defs>
    </svg>
  );
}
